import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChange,
} from '@angular/core';
import { Project } from '../../../model/project/project';
import Windowsticker from '../../../model/product/windowsticker/windowsticker';
import { ProductTypes } from '../../../model/product/product-type';
import { RequestService } from 'src/app/services/request.service';
import { AsyncChildRenderComponent } from 'src/app/subscription-helpers/async-child-render.component';
import { LoadingService } from 'src/app/services/loading.service';
import BrowserHelper from '../../../helpers/browser-helper';
import PMSColor from 'src/app/model/company/pmscolor';
import { Subject } from 'rxjs';
import { ModalService } from '../../../services/modal.service';
import Company from 'src/app/model/company/company';
import { StandardStickerPartDeletedEvent } from 'src/app/events/standard-sticker-part-deleted';
import OtherProduct from 'src/app/model/product/other-product/other-product';
import { StringHelper } from 'src/app/helpers/string-helper';
import { ProductDeletedService } from 'src/app/services/product-deleted-service';
import { CollectionHelper } from 'src/app/helpers/collection-helper';

@Component({
  selector: 'product-wrapper',
  templateUrl: './product-wrapper.component.html',
  styleUrls: ['./product-wrapper.component.scss'],
})
export class ProductWrapperComponent
  extends AsyncChildRenderComponent
  implements OnInit, OnChanges
{
  @Input()
  public index = 0;
  @Input()
  public inputProject: Project;
  @Input()
  public inputProduct: Windowsticker;
  @Input()
  public involvedCompanies: Company[];
  @Input()
  public pmsColorAdded: Subject<PMSColor>;
  @Input()
  public standardStickerPartDeleted: Subject<StandardStickerPartDeletedEvent>;
  @Input()
  public client = false;
  @Input()
  public fromOldSystem = false;
  @Input()
  public disabled = false;
  @Output()
  public outputProduct = new EventEmitter();
  @Input()
  public isCollapsed = true;
  private collapsibleClicked = false;
  public duplicateDisabled = false;
  safari: boolean;

  constructor(
    private requestService: RequestService,
    private loadingService: LoadingService,
    private modalService: ModalService,
    private productDeletedService: ProductDeletedService
  ) {
    super();
  }

  ngOnInit() {
    this.safari = BrowserHelper.isSafari();
    if (this.inputProduct.id == null) {
      this.isCollapsed = false;
      this.collapsibleClicked = true;
      this.renderChildren.next(true);
    }
  }

  ngOnChanges(changes) {
    if (changes.isCollapsed) {
      const change: SimpleChange = changes.isCollapsed;
      if (change.currentValue === false) {
        this.collapsibleClicked = true;
        this.renderChildren.next(true);
      }
    }
  }

  isWindowSticker() {
    return this.inputProduct.type === ProductTypes.WINDOWSTICKER.value;
  }

  isCustomWindowSticker() {
    return this.inputProduct.type === ProductTypes.CUSTOMWINDOWSTICKER.value;
  }

  isBoard() {
    return this.inputProduct.type === ProductTypes.BOARD.value;
  }

  isOtherProduct() {
    return this.inputProduct.type === ProductTypes.OTHER_PRODUCT.value;
  }

  getOtherProductLabel() {
    const otherProduct = <OtherProduct>this.inputProduct;
    return StringHelper.isEmpty(otherProduct.otherProductName)
      ? 'Andere'
      : otherProduct.otherProductName;
  }

  deleteProduct() {
    this.modalService.confirmDialog(
      'Product verwijderen',
      'Bent u zeker dat u dit product wilt verwijderen?',
      (answer) => {
        if (answer) {
          let index = this.inputProject.products.indexOf(this.inputProduct);
          const removedProduct = this.inputProject.products.splice(index, 1)[0];
          this.deleteProductPriceLines(removedProduct.id);
          this.productDeletedService
            .getProductDeletedSubscribable()
            .next(removedProduct.id);
          this.outputProduct.emit();
        }
      }
    );
  }

  deleteProductPriceLines(id: number) {
    if (id == null) {
      return;
    }
    this.inputProject.subProjects.forEach((sp) => {
      if (CollectionHelper.isPopulated(sp.projectInvoices)) {
        sp.projectInvoices.forEach((pi) => {
          if (CollectionHelper.isPopulated(pi.priceLines)) {
            pi.priceLines = pi.priceLines.filter(
              (pl) => pl.product == null || pl.product.id !== id
            );
          }
        });
      }
    });
  }

  copyProduct() {
    this.modalService.confirmDialog(
      'Product dupliceren',
      'Bent u zeker dat u dit product wil dupliceren?',
      (answer) => {
        if (!answer) {
          return;
        }
        this.duplicateDisabled = true;
        this.loadingService.isLoading();
        this.addSubscription(
          this.requestService.post(
            {},
            '/products/duplicate/' + this.inputProduct.id
          ),
          (d) => {
            this.inputProject.products.push(d);
            this.isCollapsed = true;
            this.duplicateDisabled = false;
            this.outputProduct.emit();
          }
        );
      }
    );
  }

  toggleCollapsed(): void {
    this.isCollapsed = !this.isCollapsed;
    if (!this.collapsibleClicked) {
      this.collapsibleClicked = true;
      this.renderChildren.next(true);
    }
  }
}
